import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/product";

export const getMsOrderFromPatientAdvice = (searchObject) =>
  axios.post(API_PATH + "/get-ms-order-from-patient-advice", searchObject);

export const getListDrugOrderAdvicePatient = (searchObject) =>
  axios.post(API_PATH + "/get-list-drug-order-advice-patient", searchObject);

export const initStoreRequest = (searchObject) =>
  axios.post(API_PATH + "/init-store-request", searchObject);

export const initChangeProduct = (productId) =>
  axios.get(API_PATH + "/init-change-product/" + productId);
export const unLockProduct = (productId) =>
  axios.get(API_PATH + "/un-lock-product/" + productId);
